import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss'
})
export class AuthCallbackComponent implements OnInit {
  constructor(private readonly router: Router, private readonly route: ActivatedRoute){
    sessionStorage.removeItem('hasLoaded');
    route.queryParams.subscribe((_: Params) => {
      if (!_) { this.router.navigate(['\\']); }
    });
  }
  ngOnInit(): void {
    let redirectUrl = localStorage.getItem('dexio_redirect') ?? "/";
    if (redirectUrl.startsWith('/callback') || redirectUrl.startsWith('/dexioauth/callback')) { redirectUrl = "/"; }
    localStorage.removeItem('dexio_redirect');
    this.router.navigate([redirectUrl]);
  }
}
